<template>
	<div class="contact-page">
		<NavMenu :blackMenu="true"></NavMenu>
		<img class="contact-img" src="../assets/img/contact.png" alt="">
		<div class="footer">
			<div class="footer-content">
				<img src="../assets/img/business.png" alt="">
				<div>京公网安备11010502050484号 </div>
			</div>
			<div class="footer-content">
				<img src="../assets/img/police.png" alt="">
				<div>京ICP备2022023247号-1</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NavMenu from '../components/nav.vue';
	export default {
		name: 'about',
		components: {
			NavMenu,
		},
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.contact-page {
		width: 100%;
		height: 100vh;
		position: relative;
	}
	.contact-img {
		width: 180px;
		position: absolute;
		transform: translate(-50%, -50%);
		top: 50%;
		left: 50%;
	}
	.footer {
		position: absolute;
		bottom: 26px;
		width: 100%;
		text-align: center;
		color: #626262;
		font-size: 10px;
	}
	.footer-content {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.footer img {
		width: 12px;
		height: 12px;
		margin-right: 4px;
	}
</style>